import moment from "moment";

export const convertDateToString = (datetime) => {
  const dateTime = moment(datetime);

  return dateTime.format("YYYY-MM-DD HH:mm");
};

export const dateForInput = (date) => {
  return new Date(date.getTime() + new Date().getTimezoneOffset() * -60 * 1000)
    .toISOString()
    .slice(0, 16);
};
